import {
    CreateOrEditCredentialDto,
    EventListDto,
    TerminalSettingDto,
} from "./../../shared/service-proxies/service-proxies";
import {
    Component,
    ElementRef,
    Injector,
    OnInit,
    ViewChild,
    ViewEncapsulation,
} from "@angular/core";
import { Router } from "@angular/router";
import { appModuleAnimation } from "@shared/animations/routerTransition";
import { AppComponentBase } from "@shared/common/app-component-base";
import {
    CredentialsServiceProxy,
    RegistrationsServiceProxy,
    RegistrationUserDto,
} from "@shared/service-proxies/service-proxies";
import { CongressWarnModalComponent } from "congress/shared/layout/congress-warn-modal/congress-warn-modal.component";
import { TerminalSettingsService } from "congress/shared/layout/terminal/terminal-settings.service";

declare var JsBarcode: any;
declare var jsPDF: any;

@Component({
    selector: "app-credential",
    templateUrl: "./credential.component.html",
    styleUrls: [
        "./credential.component.css",
        "../shared/common/styles/congress.css",
    ],
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()],
})
export class CredentialComponent extends AppComponentBase implements OnInit {
    @ViewChild("namecredential") namecredential: ElementRef;
    @ViewChild("congressWarnModal")
    congressWarnModal: CongressWarnModalComponent;

    saving = false;
    loaded = false;
    editing = false;

    userLogged = this.appSession.user;
    userToCredential: RegistrationUserDto = undefined;
    hasCredential = undefined;
    _settings: TerminalSettingDto = undefined;
    congress: EventListDto = undefined;

    eventId = undefined;
    registrationId = undefined;
    inscricaoIdFormat = undefined;
    showCredential = false;
    name = undefined;
    city = undefined;
    state = undefined;
    cityAndState = undefined;

    messageTitle = undefined;
    messageDescription = undefined;

    constructor(
        injector: Injector,
        private _router: Router,
        private _registrationsService: RegistrationsServiceProxy,
        private _credentialService: CredentialsServiceProxy,
        private _terminalServiceSettings: TerminalSettingsService
    ) {
        super(injector);
    }

    ngOnInit() {
        this._settings = this._terminalServiceSettings.getSettings();
        if (this._settings) {
            this.congress = this._settings.eventsList[0];

            this.loadUserForCredential();
        }
    }

    ngAfterViewInit() {}

    loadUserForCredential(): void {
        this.block(".f-body");
        this._registrationsService
            .getUserForRegistration(
                this.appSession.userId,
                this.congress.id, //TODO: Adicionar evento credenciador
                undefined
            )
            .finally(() => {
                this.unBlock(".f-body");
            })
            .subscribe((result) => {
                this.userToCredential = result;
                this.showCredential =
                    result.hasPaidRegistration && !result.hasCredential;
                this.hasCredential = result.hasCredential;
                let inscricao = result.registrations.filter(
                    (x) => x.status == 1 && x.eventId == this.congress.id
                )[0];

                this.registrationId = inscricao ? inscricao.id : undefined;
                this.eventId = this.congress.id;
                this.name = result.nameForCredential;
                this.state = result.address
                    ? result.address.stateAbbreviation
                    : "";
                this.city = result.address ? result.address.city : "";

                this.cityAndState = this.city + " - " + this.state;

                this.loaded = true;

                this.showCredentialMessage();

                if (this.showCredential) {
                    var fontSizeName = this._settings.fontSizeName
                        ? this._settings.fontSizeName
                        : 16;
                    var fontSizeCity = this._settings.fontSizeCity
                        ? this._settings.fontSizeCity
                        : 12;

                    var nameEl = document.getElementById(
                        "name"
                    ) as HTMLImageElement;
                    var cityEl = document.getElementById(
                        "city"
                    ) as HTMLImageElement;

                    if (!this._settings.showCredentialBarcode) {
                        nameEl.style.marginTop = "16px";
                    }

                    nameEl.style.fontSize = fontSizeName.toString() + "px";
                    cityEl.style.fontSize = fontSizeCity.toString() + "px";

                    this.generateCode(this.registrationId);
                }
            });
    }


    showCredentialMessage() {

        if(this.userToCredential.registrationCategory && (this.userToCredential.registrationCategory.includes("Acadêmic") || this.userToCredential.registrationCategory.includes("Academi") || this.userToCredential.registrationCategory.includes("Academia de med"))){
            this.showCredential = false;
            this.messageTitle = "Credencial Indisponível!";
            this.messageDescription =   `<h4 class="text-danger">Credencial indisponível para a categoria <b>${ this.userToCredential.registrationCategory }</b>. Retire sua credencial na secretaria.</h4><h5>Clique em <strong>Continuar</strong> para ver outras opções ou <strong>Sair</strong> para sair do sistema.`;

            this.congressWarnModal.show(
                this.messageTitle,
                this.messageDescription,
                true,
                "congresso/home"
            );

        }
        else if (!this.showCredential && !this.hasCredential) {
            this.messageTitle = "Credencial Indisponível!";
            this.messageDescription =    `<h4 class="text-danger">Verifique com a administração se sua inscrição no <b>${this._settings.mainEventName}</b> foi aprovada.</h4><h5>Clique em <strong>Continuar</strong> para ver outras opções ou <strong>Sair</strong> para sair do sistema.`;

            this.congressWarnModal.show(
                this.messageTitle,
                this.messageDescription,
                true,
                "congresso/home"
            );
        } else if (!this.showCredential && this.hasCredential) {

            this.messageTitle = "Atenção!";
            this.messageDescription = '<h4 class="text-danger"><strong>As etiquetas da credencial podem ser impressas uma <b>ÚNICA</b> vez.</strong><br><span>As etiquetas de sua inscrição já foram impressas.</span></h4><h5>Clique em <strong>Continuar</strong> para ver outras opções ou <strong>Sair</strong> para sair do sistema.</h5>';

            this.congressWarnModal.show(
                this.messageTitle,
                this.messageDescription,
                true,
                "congresso/home"
            );
        }
    }

    editCredential() {
        this.editing = !this.editing;
        if (this.editing) {
            setTimeout(() => {
                this.namecredential.nativeElement.focus();
            }, 0);
        }
    }

    clickOutCrdential() {
        if (this.editing == true) this.editing = false;
    }

    generateCode(value) {
        /*A função JsBarcode não aceita string vazia*/
        if (!value) {
            value = "0";
        } else {
            value = "*9" + this.zeroFill(+value, 6) + "*";
            value = value.replace("*", "").replace("*", "").toUpperCase();
        }

        if (this._settings.showCredentialBarcode) {
            JsBarcode("#codBarras", value, {
                format: "CODE39",
                width: 1.8,
                height: 24,
                fontSize: 14,
                displayValue: false,
            });
        }

        this.inscricaoIdFormat = value;
        this.showCredential = true;
    }

    print() {
        this.saving = true;

        if (!this.name || !this.cityAndState) {
            this.message.error(
                "Informe nome, cidade e estado",
                "Credencial incompleta!"
            );

            this.saving = false;
            return;
        }

        var nome = this.name;
        var city = this.cityAndState;
        var fontSizeName = this._settings.fontSizeName
            ? this._settings.fontSizeName
            : 16;
        var fontSizeCity = this._settings.fontSizeCity
            ? this._settings.fontSizeCity
            : 12;

        let nameHeight = this._settings.showCredentialBarcode ? 12 : 16;
        let cityHeight = this._settings.showCredentialBarcode ? 18 : 22;

        var doc = new jsPDF("l", "mm", [85, 32]);
        doc.setFontSize(11);
        doc.text(2, 6, this.registrationId.toString());
        doc.setFontSize(fontSizeName);
        doc.setFontType("bold");
        doc.text(44, nameHeight, nome, "center");
        doc.setFontType("normal");
        doc.setFontSize(fontSizeCity);
        doc.text(44, cityHeight, `${city}`, "center");

        //Adiciona código de Barras
        var onePageCanvas = document.createElement("canvas");
        var ctx = onePageCanvas.getContext("2d");
        //qualidade da imagem
        // ctx.webkitImageSmoothingEnabled = true;
        // ctx.mozImageSmoothingEnabled = true;
        ctx.imageSmoothingEnabled = true;
        //ctx.imageSmoothingQuality = "high";

        //var svg = document.getElementById('codBarras-container').innerHTML;

        //if (svg)
        //    svg = svg.replace(/\r?\n|\r/g, '').trim();
        var imageCode = document.getElementById(
            "codBarras"
        ) as HTMLImageElement;

        if (imageCode) ctx.drawImage(imageCode, 0, 0, 300, 180);
        //canvg(onePageCanvas, svg);

        var canvasDataURL = onePageCanvas.toDataURL("image/jpg", 1.0);

        doc.addImage(canvasDataURL, "JPG", 12, 19, 67, 18);

        for (let i = 0; i < this._settings.numberOfCredentialsCopy - 1; i++) {
            // Add pagina
            doc.addPage();
            doc.setFontSize(11);
            doc.text(2, 6, this.registrationId.toString());
            doc.setFontSize(fontSizeName);
            doc.setFontType("bold");
            doc.text(44, nameHeight, nome, "center");
            doc.setFontType("normal");
            doc.setFontSize(fontSizeCity);
            doc.text(44, cityHeight, `${city}`, "center");
            if (this._settings.showCredentialBarcode) {
                doc.addImage(canvasDataURL, "PNG", 12, 19, 67, 18);
            }
        }

        $("#credential").addClass("bounceOutRight");

        // SALVAR PDF
        //doc.save("CREDENCIAL.pdf");

        //IMPRESSÃO
        doc.autoPrint();

        var blobURL = doc.output("bloburl");

        var iframe = document.createElement("iframe");
        document.body.appendChild(iframe);

        iframe.style.display = "none";
        iframe.src = blobURL;
        iframe.onload = function () {
            setTimeout(function () {
                iframe.focus();
                iframe.contentWindow.print();

                $("iframe").remove();
            }, 10000);
        };

        this.saveCredential();
    }

    saveCredential() {
        this.saving;
        let input = new CreateOrEditCredentialDto();
        input.name = this.name;
        input.city = this.cityAndState;
        input.registrationId = this.registrationId;
        input.userId = this.userLogged.id;
        input.isFree = false;
        input.eventId = this.eventId;

        this._credentialService
            .createCredential(input)
            .finally(() => {
                this.saving = false;
            })
            .subscribe((result) => {
                if (!result) {
                    this.message.error(
                        "Registro de regirada não compurtado. Notifique o administrador do sistema.",
                        "Credencial não registrada!"
                    );
                } else {
                    this.notify.success("Retire sua credencial", "Bom Evento!");

                    var $this = this;
                    setTimeout(function () {
                        $this.saving = false;
                        $this.showCredential = false;
                        // $this._router.navigate(["congresso/home"]);
                        $this.congressWarnModal.show(
                            "Credencial Emitida!",
                            `<h4 class='text-primary-congress'><strong>${input.name}</strong> a SAESP agradece pela sua presença. Retire sua credencial e bom evento!</h4><h5>Clique em <strong>Continuar</strong> para ver outras opções ou <strong>Sair</strong> para sair do sistema.</h5>`,
                            true,
                            "congresso/home"
                        );
                    }, 300);
                }
            });
    }

    zeroFill(number, width) {
        width -= number.toString().length;
        if (width > 0) {
            return (
                new Array(width + (/\./.test(number) ? 2 : 1)).join("0") +
                number
            );
        }
        return number + "";
    }
}



// WEBPACK FOOTER //
// ./src/congress/credential/credential.component.ts